import { Select } from 'antd';
import React from 'react';

const NO_FLAG = '';

interface FeatureFlagSelectProps {
    value: string | null;
    flagNames: string[];
    loading?: boolean;
    className?: string;
    onChange: (value: string | null) => void;
}

export const FeatureFlagSelect = ({
    value,
    flagNames,
    loading,
    className,
    onChange,
}: FeatureFlagSelectProps) => (
    <Select<string>
        className={className}
        loading={loading}
        value={value ?? NO_FLAG}
        options={[
            { value: NO_FLAG, label: 'None' },
            ...flagNames.map((name) => ({ value: name, label: name })),
        ]}
        onChange={(selected) =>
            onChange(selected === NO_FLAG ? null : selected)
        }
    />
);
